export default "__VITE_ASSET__KoKk3n5B__"